import { BordOneToneIcon } from 'components/NudosComponents';
import QuoteDetailApprovalCounter from './components/QuoteDetailApprovalCounter/QuoteDetailApprovalCounter';
import QuoteDetailSummaryStats from './components/QuoteDetailSummaryStats/QuoteDetailSummaryStats';
import QuoteDetailSummarySkeleton from './components/QuoteDetailSummarySkeleton/QuoteDetailSummarySkeleton';
import { IQuoteSummary, IQuoteDetailSla, IQuoteItem } from 'types/quote.types';
import { QUOTE_STATUS_CODE } from 'types/quoteDetails.types';

import './QuoteDetailSummary.scss';

interface IQuoteDetailSummary {
  isLoading?: boolean;
  summary?: IQuoteSummary;
  quoteId?: number;
  clientName?: string;
  countryName?: string;
  countryCode?: string;
  organizationId?: number;
  onSendSuccess?: () => void;
  slas?: IQuoteDetailSla[];
  quoteStatusCode?: QUOTE_STATUS_CODE;
  items: IQuoteItem[];
  parentQuoteId?: number;
}

/**
 * Resumen de la cotización: herramientas cotizadas, aprobadas, rechazadas, compradas y totales.
 */
const QuoteDetailSummary = ({
  isLoading,
  summary,
  quoteId,
  clientName,
  countryName,
  countryCode,
  organizationId,
  onSendSuccess,
  slas,
  quoteStatusCode,
  items,
  parentQuoteId
}: IQuoteDetailSummary) => {
  const showSummary = summary?.quotationSent;
  if (isLoading) return <QuoteDetailSummarySkeleton />;
  return (
    <div className="quoteDetailSummary">
      <div className="summaryHeader">
        <div className="summaryHeaderIcon">
          <BordOneToneIcon variant="filePlus" stroke="#6F737D" standardSize={18} />
        </div>
        <span className="summaryTitle">Resumen de la cotización</span>
      </div>
      {showSummary ? (
        <QuoteDetailSummaryStats summary={summary} quoteId={quoteId} slas={slas} />
      ) : (
        <QuoteDetailApprovalCounter
          summary={summary}
          quoteId={quoteId}
          clientName={clientName}
          countryName={countryName}
          countryCode={countryCode}
          organizationId={organizationId}
          onSendSuccess={onSendSuccess}
          quoteStatusCode={quoteStatusCode}
          items={items ?? []}
          parentQuoteId={parentQuoteId}
        />
      )}
    </div>
  );
};

export default QuoteDetailSummary;
